import axios, { AxiosInstance } from 'axios';

/**
 * Builds Axios instances with different base URLs.
 *
 * @param {String} baseURL
 * @returns {AxiosInstance}
 */
export const createAxiosInstance: (baseURL: string) => AxiosInstance = baseURL =>
  axios.create({
    baseURL,
    headers: { 'content-type': 'application/json' }
  });

/** Axios base instance */
export const axiosBaseInstance = createAxiosInstance(window.__env__.API_URL);

/** Axios instance for integrations service */
export const axiosIntegrationsBaseInstance = createAxiosInstance(window.__env__.INTEGRATIONS_API_URL);
